import "resources/css/components/image.css"

import React from "react"
import cx from "classnames"

export const ImageCircle = ({src, className}) => (
  <div className={cx("image rounded-full", className)} style={{backgroundImage: `url(${src})`}} />
)

export const ConsignCloudLogo = () => <img className="w-8 pb-2" src="/public/brandmark-dark.png" />
